import { SidebarHeader } from 'components/ui/sidebar';
import { SearchForm } from './search-form';
import { useNavigate } from 'react-router-dom';
import GavLogo from "@/assets/png/gav-extended.png";
import { getEnvironmentConfig, isProduction } from '@/utils/environment';
import { cn } from '@/lib/utils';

const SidebarTopHeader = () => {
    const navigate = useNavigate()
    const envConfig = getEnvironmentConfig();
    const showEnvBanner = !isProduction();

    return (
        <SidebarHeader className="bg-white flex flex-col gap-3 p-3 border-b shrink-0">
            {showEnvBanner && (
                <div
                    className={cn(
                        'w-full py-2 px-3 text-center text-xs font-semibold rounded-md border',
                        envConfig.color,
                        envConfig.bgColor,
                        envConfig.borderColor
                    )}
                >
                    {envConfig.label}
                </div>
            )}
            <div className="w-full flex items-center justify-center">
                <img
                    onClick={() => {
                        navigate("/");
                    }}
                    src={GavLogo}
                    alt="Gav Logo"
                    className="w-36 p-2 cursor-pointer"
                />
            </div>
            <SearchForm />
        </SidebarHeader>
    )
}

export default SidebarTopHeader
